"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDependencyError = exports.tapUseCaseError = exports.UseCaseErrorKind = void 0;
const api_1 = require("@opentelemetry/api");
var UseCaseErrorKind;
(function (UseCaseErrorKind) {
    UseCaseErrorKind["Validation"] = "validation";
    UseCaseErrorKind["DependencyError"] = "dependency-error";
    UseCaseErrorKind["NotFound"] = "not-found";
    UseCaseErrorKind["NotAuthorized"] = "not-authorized";
    UseCaseErrorKind["Conflict"] = "conflict";
})(UseCaseErrorKind || (exports.UseCaseErrorKind = UseCaseErrorKind = {}));
const tapUseCaseError = (label, span, cause) => {
    const message = `${label} nested use case error - '${cause.message}'`;
    span.setStatus({ code: api_1.SpanStatusCode.ERROR, message });
    switch (cause.kind) {
        case UseCaseErrorKind.Validation:
            return {
                kind: cause.kind,
                message,
                error: new Error(message, { cause }),
                userMessage: cause.userMessage,
            };
        default:
            return {
                kind: cause.kind,
                message,
                error: new Error(message, { cause }),
                userMessage: cause.userMessage,
            };
    }
};
exports.tapUseCaseError = tapUseCaseError;
const mapDependencyError = (message, span, cause) => {
    span.setStatus({ code: api_1.SpanStatusCode.ERROR, message });
    return {
        kind: UseCaseErrorKind.DependencyError,
        message,
        error: new Error(message, { cause }),
    };
};
exports.mapDependencyError = mapDependencyError;
//# sourceMappingURL=use-case.js.map